const STORAGE_KEY = 'merchant_theme';

export function readThemeMode() {
    try {
        const v = window.localStorage.getItem(STORAGE_KEY);
        return v === 'dark' ? 'dark' : 'light';
    } catch (e) {
        return 'light';
    }
}

export function writeThemeMode(mode) {
    const next = mode === 'dark' ? 'dark' : 'light';
    try {
        window.localStorage.setItem(STORAGE_KEY, next);
    } catch (e) {
        /* ignore */
    }
    return next;
}

export function applyThemeToDocument(mode) {
    const next = mode === 'dark' ? 'dark' : 'light';
    if (typeof document === 'undefined') {
        return next;
    }
    document.documentElement.setAttribute('data-theme', next);
    document.documentElement.style.colorScheme = next;
    return next;
}
